/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotLanguageModelMetric extends models.CopilotMetricActivityBase {
    getFixupPrototypeFunction() { return CopilotLanguageModelMetric.fixupPrototype; }

    static newInstance(model: Partial<CopilotLanguageModelMetric>): CopilotLanguageModelMetric {
        let obj = Object.assign(new CopilotLanguageModelMetric(), model);
        CopilotLanguageModelMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotLanguageModelMetric>): CopilotLanguageModelMetric {
        if (!model) return null;
        return CopilotLanguageModelMetric.newInstance(<CopilotLanguageModelMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotLanguageModelMetric) {
        if (!obj) return;

        models.CopilotLanguageModelMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotLanguageModelMetric): boolean {
        if (models.CopilotMetricActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotLanguageModelMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * AI model name (e.g. gpt-4.1, claude-4.0-sonnet)
     */
    model: string;

    /**
     * Programming language name (e.g. python, javascript)
     */
    name: string;

}
